export default [
  {
    title: 'مدیریت سفارش ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'محصول ها',
        route: { name: 'order' },
        resource: 'OrderManager',
        action: 'show',
      },
      {
        title: 'خدمات',
        route: { name: 'dutyorder' },
        resource: 'OrderManager',
        action: 'show',
      },
      {
        title: 'تخفیف ها',
        route: { name: 'coupon' },
        resource: 'CouponManager',
        action: 'show',
      },
    ],
  },
]
